import {
    Directive,
    inject,
    Input,
    TemplateRef,
    ViewContainerRef,
} from '@angular/core';

import { Role } from '@models/user';
import { UserDataService } from '@services/data/user-data.service';

@Directive({
    selector: '[wfeHasRole]',
})
export class HasRoleDirective {
    private currentRole: Role | null = null;
    private allowedRoles: Role[] = [];

    private readonly templateRef = inject(TemplateRef);
    private readonly viewContainer = inject(ViewContainerRef);
    private readonly userDataService = inject(UserDataService);

    constructor() {
        this.setCurrentRole();
    }

    @Input() set wfeHasRole(allowedRoles: Role[]) {
        this.allowedRoles = allowedRoles;
        this.updateView();
    }

    private setCurrentRole() {
        this.userDataService.user$.subscribe({
            next: (user) => {
                this.currentRole = user?.role ?? null;
                this.updateView();
            },
        });
    }

    private updateView() {
        this.viewContainer.clear();
        const hasPermission = this.allowedRoles.some(
            (role) => role === this.currentRole,
        );

        if (hasPermission) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }
}
